/**
 * KAN-883: фильтр "Появился" страницы "Лиды по теплоте": день, когда клиент
 * впервые написал. Адрес ?lead_from=&lead_to= (ГГГГ-ММ-ДД по Москве); без них -
 * "Всё время". Выбор кнопками и календарём (CrmPeriodControl).
 */
import { parseCrmRange, type CrmRange } from './crmTable';
import type { PeriodChoice } from './periodPresets';

export const LEAD_DAY_PARAM = { from: 'lead_from', to: 'lead_to' } as const;

/** Быстрые кнопки "Появился". */
export const LEAD_DAY_CHOICES: readonly PeriodChoice[] = ['all', 'today', 'yesterday', 'week', 'month'];

/** Период появления из адреса; null - всё время. */
export function parseLeadDayRange(from: string | null, to: string | null, now: Date = new Date()): CrmRange | null {
  return !from && !to ? null : parseCrmRange(from, to, now);
}

/** Адрес с периодом появления; null убирает lead_from/lead_to. */
export function withLeadDayRange(prev: URLSearchParams, range: CrmRange | null): URLSearchParams {
  const next = new URLSearchParams(prev);
  if (range) {
    next.set(LEAD_DAY_PARAM.from, range.from);
    next.set(LEAD_DAY_PARAM.to, range.to);
  } else {
    next.delete(LEAD_DAY_PARAM.from);
    next.delete(LEAD_DAY_PARAM.to);
  }
  return next;
}
